import React from "react";
import clientStorage from "../../utils/client-storage";
import routes from "../../routes";
import Loader from "../../components/Loader/Loader";
import AppContext from "../../contexts/AppContext";
import {webviewSetTitle} from "../../utils/webview";
import {generatePath} from "react-router";

export default class StartPage extends React.Component {

  componentDidMount() {
    const files = clientStorage.getLatestSelectedImages();
    if (files.isEmpty()) {
      this.props.history.replace(generatePath(routes.INDEX, {user_id: window.clientConfig.userId}) + "?reason=nofiles");
      return;
    }

    const blockData = clientStorage.getLatestBlock();
    const section = this.context.config.sections.find((section) => section.name === blockData.section);
    if (!section) {
      this.props.history.replace(generatePath(routes.INDEX, {user_id: window.clientConfig.userId}) + "?reason=nosection");
      return;
    }

    if (window.clientConfig.isWebview) {
      webviewSetTitle(section.title.en);
    }

    const block = section.blocks.find((block) => block.name === blockData.block);
    if (!block) {
      this.props.history.replace(generatePath(routes.INDEX, {user_id: window.clientConfig.userId}) + "?reason=noblock");
      return;
    }

    this.props.history.replace({
      pathname: generatePath(routes.PROCESSING),
      state: {files},
    });
  }

  render() {
    return <Loader />
  }
}

StartPage.contextType = AppContext;